import React, { useState } from "react";
import { Button, CircularProgress } from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import toast from "react-hot-toast";
import {
  canDownloadOrderInvoice,
  downloadOrderInvoicePdf,
} from "../../utils/invoicePdf";

export default function DownloadInvoiceButton({
  order,
  recipientName,
  isAdmin = false,
  variant = "outlined",
  size = "small",
  fullWidth = false,
  label = "Download Invoice",
  sx = {},
}) {
  const [loading, setLoading] = useState(false);

  if (!canDownloadOrderInvoice(order)) {
    return null;
  }

  const handleDownload = async () => {
    setLoading(true);
    try {
      await downloadOrderInvoicePdf(order, { recipientName, isAdmin });
      toast.success("Invoice downloaded");
    } catch (err) {
      console.error(err);
      toast.error(err?.message || "Could not generate invoice PDF");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Button
      variant={variant}
      size={size}
      fullWidth={fullWidth}
      startIcon={loading ? <CircularProgress size={16} color="inherit" /> : <DownloadIcon />}
      onClick={handleDownload}
      disabled={loading}
      sx={{
        textTransform: "none",
        fontWeight: 600,
        color: "#0B65B5",
        borderColor: "#0B65B5",
        "&:hover": {
          borderColor: "#094d88",
          backgroundColor: "#EAF5FF",
        },
        ...sx,
      }}
    >
      {loading ? "Generating…" : label}
    </Button>
  );
}
